"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessInstanceTerminateEvent = void 0;
const ProcessInstanceTerminateAbortEvent_1 = require("./ProcessInstanceTerminateAbortEvent");
/**
 * If you prevented the default behavior with `event.preventDefault()` and you want to abort the termination, set the event's `abort` property to `true`.
 *
 * Example:
 * `event.abort = true;`
 *
 * If you want to return an error, set the event's `error` property to the respective error.
 *
 * _Note:_ Setting these properties will only take effect, if the default event behavior was prevented.
 */
class ProcessInstanceTerminateEvent extends Event {
    constructor(processInstanceId) {
        super(ProcessInstanceTerminateEvent.type, {
            bubbles: true,
            cancelable: true,
        });
        this.aborted = false;
        this.processInstanceId = processInstanceId;
    }
    /**
     * If you want to abort the termination, after this method was invoked, set the event's `abort` property to `true`.
     *
     * Example:
     * `event.abort = true;`
     *
     * If you want to return an error, set the event's `error` property to the respective error.
     *
     *
     * If invoked with `cancelable` set to `true` and while executing an event listener with `passive` set to `false`,
     * the event source will be notified that the operation needs to be canceled.
     */
    preventDefault() {
        super.preventDefault();
    }
    set abort(value) {
        var _a;
        this.aborted = value;
        if (value === true && this.defaultPrevented) {
            (_a = this.target) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new ProcessInstanceTerminateAbortEvent_1.ProcessInstanceTerminateAbortEvent(this.processInstanceId));
        }
    }
    set error(value) {
        var _a;
        this.errored = value;
        if (value instanceof Error && this.defaultPrevented) {
            (_a = this.target) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new ProcessInstanceTerminateAbortEvent_1.ProcessInstanceTerminateAbortEvent(this.processInstanceId, value));
        }
    }
}
exports.ProcessInstanceTerminateEvent = ProcessInstanceTerminateEvent;
ProcessInstanceTerminateEvent.type = 'onProcessInstanceTerminate';
